import { Reducer } from 'redux'
import { v4 as uuid4 } from 'uuid'
import {
  ButtonCreationActionTypes,
  type ButtonCreationAction,
  type ButtonInCreation,
  initialButtonInCreationState,
} from './types'

export * from './types'

export const reducer: Reducer<ButtonInCreation, ButtonCreationAction> = (
  state = initialButtonInCreationState,
  action
) => {
  switch (action.type) {
    case ButtonCreationActionTypes.SET_CREATE_BUTTON_DATA: {
      return {
        ...state,
        buttonData: {
          ...state.buttonData,
          ...action.payload,
        },
      }
    }
    case ButtonCreationActionTypes.CLEAR_CURRENT_BUTTON_DATA:
      return {
        ...initialButtonInCreationState,
        buttonData: {
          ...initialButtonInCreationState.buttonData,
          product: [
            {
              uniqueId: String(uuid4()),
              url: '',
              isOpen: true,
              isLoading: false,
            },
          ],
        },
      }

    default: {
      return state
    }
  }
}
